/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.index.page.copilot.rpc.ViewGenerationService
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const generateViewRpc = {
  serviceName: 'com.hubspot.index.page.copilot.rpc.ViewGenerationService',
  rpcName: 'generateView',
  auth: 'app',
  fingerprint: 'vhjqxxWbcpMrhBE9-5LzTZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const generateViewDebugRpc = {
  serviceName: 'com.hubspot.index.page.copilot.rpc.ViewGenerationService',
  rpcName: 'generateViewDebug',
  auth: 'app',
  fingerprint: 'vhjqxxWbcpP-ADIXySraR5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const generateAndCreateViewRpc = {
  serviceName: 'com.hubspot.index.page.copilot.rpc.ViewGenerationService',
  rpcName: 'generateAndCreateView',
  auth: 'app',
  fingerprint: 'vhjqxxWbcpOSK2busYfp8ZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const generateDefaultViewRpc = {
  serviceName: 'com.hubspot.index.page.copilot.rpc.ViewGenerationService',
  rpcName: 'generateDefaultView',
  auth: 'app',
  fingerprint: 'G_NKOBTz_y8rhBE9-5LzTZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const generateDefaultViewDebugRpc = {
  serviceName: 'com.hubspot.index.page.copilot.rpc.ViewGenerationService',
  rpcName: 'generateDefaultViewDebug',
  auth: 'app',
  fingerprint: 'G_NKOBTz_y_-ADIXySraR5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const generateAndCreateDefaultViewRpc = {
  serviceName: 'com.hubspot.index.page.copilot.rpc.ViewGenerationService',
  rpcName: 'generateAndCreateDefaultView',
  auth: 'app',
  fingerprint: 'G_NKOBTz_y-SK2busYfp8ZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const generateViewWithCombinedLlmModulesRpc = {
  serviceName: 'com.hubspot.index.page.copilot.rpc.ViewGenerationService',
  rpcName: 'generateViewWithCombinedLlmModules',
  auth: 'app',
  fingerprint: 'vhjqxxWbcpMrhBE9-5LzTZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const generateViewWithCombinedLlmModulesDebugRpc = {
  serviceName: 'com.hubspot.index.page.copilot.rpc.ViewGenerationService',
  rpcName: 'generateViewWithCombinedLlmModulesDebug',
  auth: 'app',
  fingerprint: 'vhjqxxWbcpP-ADIXySraR5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const generateViewAndCreateWithCombinedLlmModulesRpc = {
  serviceName: 'com.hubspot.index.page.copilot.rpc.ViewGenerationService',
  rpcName: 'generateViewAndCreateWithCombinedLlmModules',
  auth: 'app',
  fingerprint: 'vhjqxxWbcpOSK2busYfp8ZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const generateViewAndUpdateWithCombinedLlmModulesRpc = {
  serviceName: 'com.hubspot.index.page.copilot.rpc.ViewGenerationService',
  rpcName: 'generateViewAndUpdateWithCombinedLlmModules',
  auth: 'app',
  fingerprint: 'NGgkZ5ArJbCSK2busYfp8ZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const generateViewWithoutSaveWithCombinedLlmModulesRpc = {
  serviceName: 'com.hubspot.index.page.copilot.rpc.ViewGenerationService',
  rpcName: 'generateViewWithoutSaveWithCombinedLlmModules',
  auth: 'app',
  fingerprint: 'vhjqxxWbcpPcVxyIFGSAdZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};